/**
 * @generated SignedSource<<98ff0a2089d9e12166d5feecfa056875>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontProductTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ItemFolderWrapper_viewer" | "ItemHeartWrapper_viewer">;
  readonly " $fragmentType": "StorefrontProductTile_viewer";
};
export type StorefrontProductTile_viewer$key = {
  readonly " $data"?: StorefrontProductTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontProductTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontProductTile_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "hasUserId"
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemHeartWrapper_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemFolderWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "44803ace31c15032c63629f6cc701844";

export default node;
